/* RB collection grid (Oct 21, 2026, sprint 2, collections stream, audit N1): the colour dots on the cards and the filter
   bar of sections/rb-collection-grid. Markup: snippets/rb-coll-card (dots + data-* on each card) and the section (the
   bar, the count line, the "nothing matches" box). Styles: assets/rb-quick-add.css. Loaded by the section only (defer).
   Everything is printed by Liquid first, so nothing moves when this runs; without it the cards are plain links.
   - Colour dots (<button aria-pressed> in .rb-coll__dots): a tap swaps the card's photo (srcset first, then src, so
     the browser never fetches the wrong width; same aspect ratio, so nothing jumps), its alt, the card link, the colour
     line under the title, and the colour the "+ הוספה" sheet starts on (data-rb-qa-preset, read by
     assets/rb-quick-add.js when the sheet opens; works on the tile's link and, once that script has turned it into a
     <button>, on the button via data-url). aria-pressed marks the colour shown.
   - Filters: type chips (one at a time, "הכל" = all: data-rb-type=""), size buttons (any number: a card shows when it
     has one of them), "רק מה שבמלאי" (data-rb-stock). A size alone matches data-sizes (sizes the product comes in);
     with "in stock only" it matches data-sizes-in (sizes some colour still has). With a type chip on, size buttons
     that no card of that type comes in are hidden and let go (sizesForType). Cards are hidden with the hidden
     attribute. The count line (role=status) is emptied, then refilled 60 ms later, so a repeated text is announced
     again. "ניקוי הסינון" resets everything and puts focus on the first filter button (it may have been inside the
     "nothing matches" box, which closes).
   - With desktop tabs (section setting), the type chips are hidden from 990px (the tabs do that job: the type filter
     is then ignored) and the count is for the open tab; a tab change (rb:tab-change from rb-brand.js) recounts.
   - Theme editor: a re-rendered section is set up again (shopify:section:load).
   Oct 22, 2026:
   - A colour dot also passes its photo's shape (data-ar, width / height) to the card's frame as --rb-ar, so the
     rounded photo box (assets/rb-quick-add.css) always matches the photo shown.
   - The size buttons, "רק מה שבמלאי", the visible count row, "ניקוי הסינון" and the "nothing matches" box are now
     off by default (section setting "Size buttons and in stock only"): with only the type chips the page has none of
     them, and every lookup below is null-checked, so the chips still filter and the count (then visually hidden) is
     still announced.
   Nov 2, 2026 (Amit, ShoppingIL): the section now also loads this with "One card per colour" on, for the type chips
   only. Those cards carry data-rb-tile, data-type and data-avail but no data-sizes (parse() gives []), and no colour
   dots, so only the chip filter and the count run; the count is then colour cards ("12 מתוך 19 מוצרים"). Nothing in
   here changed for it. */
(function () {
  if (window.__rbCollLoaded) return;
  window.__rbCollLoaded = true;

  var desk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function parse(s, d) { try { var v = JSON.parse(s); return v == null ? d : v; } catch (e) { return d; } }
  function shown(e) { return !!(e && e.getClientRects().length && !e.closest('[hidden]')); }
  function focusEl(e) { if (!e || !e.focus) return; try { e.focus({ preventScroll: true }); } catch (x) { e.focus(); } }

  /* ---------- colour dots ---------- */
  function showColour(dot) {
    var card = dot.closest('.rb-coll__card');
    if (!card) return;
    $$('[data-rb-dot]', card).forEach(function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
    var url = dot.getAttribute('data-url');
    var img = card.querySelector('img.rb-coll__img');
    var src = dot.getAttribute('data-src');
    var media = card.querySelector('.rb-coll__media');
    var ar = dot.getAttribute('data-ar');
    if (media && ar) media.style.setProperty('--rb-ar', ar);
    if (img && src && img.getAttribute('src') !== src) {
      var ss = dot.getAttribute('data-srcset');
      if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }
    if (img && dot.hasAttribute('data-alt')) img.setAttribute('alt', dot.getAttribute('data-alt'));
    var link = card.querySelector('.rb-coll__link');
    if (link && url) link.setAttribute('href', url);
    var line = card.querySelector('[data-rb-coll-color]');
    if (line) line.textContent = dot.getAttribute('data-label') || '';
    var qa = card.querySelector('[data-rb-qa-open]');
    if (qa) {
      qa.setAttribute('data-rb-qa-preset', dot.getAttribute('data-v') || '');
      if (url) qa.setAttribute(qa.tagName === 'A' ? 'href' : 'data-url', url);
    }
  }

  /* ---------- one grid ---------- */
  function setup(root) {
    if (!root || root.__rbColl) return;
    root.__rbColl = true;
    var T = parse(root.getAttribute('data-rb-coll-t'), {});
    var cards = $$('.rb-coll__card[data-rb-tile]', root);
    cards.forEach(function (c) {
      c._all = parse(c.getAttribute('data-sizes'), []);
      c._in = parse(c.getAttribute('data-sizes-in'), []);
    });
    var countEl = root.querySelector('[data-rb-coll-count]');
    var emptyEl = root.querySelector('[data-rb-coll-empty]');
    var resetEl = root.querySelector('[data-rb-coll-reset]');
    var st = { type: '', sizes: [], stock: false };
    var timer = 0;

    function tabsOn() { return root.classList.contains('rb-coll--tabs') && !!desk && desk.matches; }
    function typeOn() { return !!st.type && !tabsOn(); }
    function active() { return typeOn() || st.stock || st.sizes.length > 0; }
    function fits(c) {
      if (typeOn() && c.getAttribute('data-type') !== st.type) return false;
      if (st.stock && c.getAttribute('data-avail') !== '1') return false;
      if (st.sizes.length) {
        var list = st.stock ? c._in : c._all;
        if (!st.sizes.some(function (s) { return list.indexOf(s) > -1; })) return false;
      }
      return true;
    }
    // With desktop tabs only the open tab's cards count
    function counted(c) {
      if (!tabsOn()) return true;
      var p = c.closest('[role="tabpanel"]');
      return !p || !p.hidden;
    }
    function label(n, t) {
      if (n === t) return t === 1 ? String(T.one || '1') : String(T.many || '[n]').replace('[n]', t);
      return String(T.of || '[n] / [t]').replace('[n]', n).replace('[t]', t);
    }
    function apply(say) {
      var n = 0, t = 0;
      cards.forEach(function (c) {
        var ok = fits(c);
        if (c.hidden === ok) c.hidden = !ok;
        if (counted(c)) { t++; if (ok) n++; }
      });
      if (emptyEl) emptyEl.hidden = n > 0 || t === 0;
      if (resetEl) resetEl.hidden = !active();
      if (!countEl) return;
      var s = label(n, t);
      clearTimeout(timer);
      if (say) { countEl.textContent = ''; timer = setTimeout(function () { countEl.textContent = s; }, 60); }
      else if (countEl.textContent !== s) countEl.textContent = s;
    }
    function press(sel, on) { $$(sel, root).forEach(function (b) { b.setAttribute('aria-pressed', on(b) ? 'true' : 'false'); }); }
    // With a type chip on, only the sizes that type comes in (on /collections: pyjamas = XS–XL). A pressed size that
    // goes away is let go, so a hidden button never filters.
    function sizesForType() {
      var have = {};
      cards.forEach(function (c) {
        if (typeOn() && c.getAttribute('data-type') !== st.type) return;
        c._all.forEach(function (s) { have[s] = true; });
      });
      var any = false;
      $$('[data-rb-size]', root).forEach(function (b) {
        var v = b.getAttribute('data-rb-size'), ok = !!have[v];
        if (ok) any = true;
        if (b.hidden === ok) b.hidden = !ok;
        if (!ok && st.sizes.indexOf(v) > -1) { st.sizes.splice(st.sizes.indexOf(v), 1); b.setAttribute('aria-pressed', 'false'); }
      });
      // Review (Oct 22, 2026): a type with no sizes at all (gift card, "עוד") hides the whole size row, label included,
      // instead of leaving "מידה" above an empty row.
      var grp = root.querySelector('.rb-coll__sizes');
      if (grp && grp.hidden === any) grp.hidden = !any;
    }

    root.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-rb-dot')) { showColour(b); return; }
      if (b.hasAttribute('data-rb-type')) {
        st.type = b.getAttribute('data-rb-type') || '';
        press('[data-rb-type]', function (x) { return (x.getAttribute('data-rb-type') || '') === st.type; });
        sizesForType();
        apply(true);
        return;
      }
      if (b.hasAttribute('data-rb-size')) {
        var v = b.getAttribute('data-rb-size'), i = st.sizes.indexOf(v);
        if (i > -1) st.sizes.splice(i, 1); else st.sizes.push(v);
        b.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
        apply(true);
        return;
      }
      if (b.hasAttribute('data-rb-stock')) {
        st.stock = !st.stock;
        b.setAttribute('aria-pressed', st.stock ? 'true' : 'false');
        apply(true);
        return;
      }
      if (b.hasAttribute('data-rb-coll-clear')) {
        st = { type: '', sizes: [], stock: false };
        press('[data-rb-type]', function (x) { return !x.getAttribute('data-rb-type'); });
        press('[data-rb-size], [data-rb-stock]', function () { return false; });
        sizesForType();
        apply(true);
        focusEl($$('.rb-coll__filters button', root).filter(shown)[0]);
      }
    });
    root.addEventListener('rb:tab-change', function () { apply(false); });
    if (desk) {
      var onMq = function () { sizesForType(); apply(false); };
      if (desk.addEventListener) desk.addEventListener('change', onMq); else if (desk.addListener) desk.addListener(onMq);
    }
    if (root.classList.contains('rb-coll--tabs')) apply(false);   // desktop tabs: count the open tab only
  }

  function init(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-rb-coll]')) setup(scope);
    $$('[data-rb-coll]', scope).forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
